import React from 'react';
import { Link } from 'react-router-dom';
import { NO_REFUND_POLICY_TEXT } from '../lib/storePolicies';

const pageContent = {
  shipping: {
    eyebrow: 'Shipping & delivery',
    title: 'Clear delivery information before you pay.',
    intro: 'Delivery charges and availability are shown at checkout once you add your address.',
    sections: [
      ['Delivery charges', 'Delivery is priced at checkout using the product source location, package details, destination pincode, and the available carrier service.'],
      ['Delivery updates', 'Use Track Order after you place an order. If you need help with an address or delivery update, contact the shop with your order number.'],
    ],
  },
  returns: {
    eyebrow: 'Returns & exchanges',
    title: 'Need help with an order?',
    intro: 'Please contact the shop first if an item arrives damaged or there is a problem with your order.',
    sections: [
      ['No refunds', NO_REFUND_POLICY_TEXT],
      ['How to get help', 'Share your order number, a short description of the issue, and photos when they help explain the problem. The team will review the available options with you.'],
      ['Before sending anything back', 'Wait for the shop to reply before returning an item, so the correct next step can be confirmed for your order.'],
    ],
  },
  help: {
    eyebrow: 'Order help',
    title: 'Support for orders and custom gifts.',
    intro: 'Get help with order tracking, delivery questions, product details, or a custom gift request.',
    sections: [
      ['Existing orders', 'Open Track Order to review your order history. Include your order number when you contact the shop for faster help.'],
      ['Custom requests', 'Use Custom orders to describe what you would like made, share your preferences, and continue the conversation with the Hunar team.'],
    ],
  },
};

export default function StoreInfoPage({ type }) {
  const content = pageContent[type] || pageContent.help;

  return (
    <div className="container store-info-page py-5">
      <p className="store-info-page__eyebrow">{content.eyebrow}</p>
      <h1 className="brand-font store-info-page__title">{content.title}</h1>
      <p className="store-info-page__intro">{content.intro}</p>

      <div className="store-info-page__grid">
        {content.sections.map(([heading, copy]) => (
          <section key={heading} className="store-info-page__card">
            <h2>{heading}</h2>
            <p>{copy}</p>
          </section>
        ))}
      </div>

      <section className="store-info-page__contact" aria-label="Contact the shop">
        <h2>Contact Hunar</h2>
        <p><a href="mailto:lakshaychawla13@gmail.com">lakshaychawla13@gmail.com</a></p>
        <div className="d-flex flex-wrap gap-2">
          <Link to="/orders" className="btn btn-primary-custom">Track order</Link>
          <Link to="/custom-orders" className="btn btn-outline-custom">Request a custom order</Link>
          <Link to="/shop" className="btn btn-outline-custom">Continue shopping</Link>
        </div>
      </section>
    </div>
  );
}
